var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-loader"},[_vm._t("default",function(){return [_c('svg',{staticClass:"spinner",attrs:{"viewBox":"0 0 50 50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke-width":"5"}})])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }